import {Component, Vue} from 'vue-property-decorator'
import { getFinanceOrdreListByCustomerId} from "@/api/projectList";

@Component({})
export default class FollowRecord extends Vue {
    tableData = []
    id: number;
    loading = false
    customerId: number
    customerType: string

    created() {
        this.id = Number(this.$route.query.id)
        this.customerId = Number(this.$route.query.customerId)
        this.customerType = String(this.$route.query.customerType)
        this.getTableData()
    }

    async getTableData() {
        this.loading = true
        const data: any = await getFinanceOrdreListByCustomerId({
            id: this.id,
            customerId: this.customerId,
            customerType: this.customerType
        })
        this.tableData = data.financeOrderList
        this.loading = false
    }

    // 跳转新建回款
    returnBackMoney(row) {
        window.open(window.location.origin + '/financialCenter/newBackMoneyStudent?orderId='+row.id+'&isFrom=1', '_blank')
    }
}
